import React, { useState, useEffect } from 'react';
import {
  Button,
  TableCell,
  TableRow,
  Chip,
  Avatar,
  Typography,
} from '@material-ui/core';
import AssignmentIcon from '@material-ui/icons/Assignment';
import moment from 'moment';
import CropDinRoundedIcon from '@material-ui/icons/CropDinRounded';
import {
  UserProductPackageOrderStatus,
  UserProductPackageOrderStatusText,
  UserProductPackagePayType,
  UserProductPackagePayTypeText,
} from '../../data/common';
import { forEach } from 'lodash';
import { findCover } from '../../Util/Util';
import CheckRoundedIcon from '@material-ui/icons/CheckRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import GroupProductTableCell from './GroupProductTableCell';
import CreditCardRoundedIcon from '@material-ui/icons/CreditCardRounded';
import LocalAtmRoundedIcon from '@material-ui/icons/LocalAtmRounded';
import FaceRoundedIcon from '@material-ui/icons/FaceRounded';

const UserProductPackageOrderTableRow = (props) => {
  const { userProductPackage, openDetail } = props;
  const [cover, setCover] = useState();
  const [countProducts, setCountProducts] = useState();

  useEffect(() => {
    if (userProductPackage) {
      setCover(
        findCover(
          userProductPackage.userProductPackageDetail.packageInfo
            .packageProductImageList,
        ),
      );

      let newCountProducts = {};

      forEach(
        userProductPackage.userProductPackageDetail.packageDetail,
        (userProduct) => {
          const groupKey = userProduct.isGift
            ? 'gift_' + userProduct.bonusProductId
            : '' + userProduct.bonusProductId;

          if (!newCountProducts[groupKey]) {
            newCountProducts[groupKey] = {
              name: userProduct.productInfo.name,
              total: 0,
              isGift: userProduct.isGift,
            };
          }

          newCountProducts[groupKey].total =
            newCountProducts[groupKey].total + 1;
        },
      );

      setCountProducts(newCountProducts);
    }
  }, [userProductPackage]);

  const handleOpenDetail = () => {
    openDetail(userProductPackage);
  };

  return (
    <TableRow>
      <TableCell component="th">
        {cover && <Avatar src={cover.imageUrl} />}

        {!cover && (
          <Avatar>
            <CropDinRoundedIcon />
          </Avatar>
        )}
      </TableCell>
      <TableCell component="th">
        {userProductPackage.userProductPackageDetail.packageInfo.name}
      </TableCell>
      <TableCell>
        <Chip
          avatar={
            <Avatar
              src={
                userProductPackage.userProductPackageDetail.packageInfo
                  .storeInfo.imgSrc
              }
            />
          }
          size="small"
          label={
            userProductPackage.userProductPackageDetail.packageInfo.storeInfo
              .name
          }
        />
      </TableCell>
      <TableCell>$ {userProductPackage.price}</TableCell>
      <TableCell component="th">
        {userProductPackage.userInfo.realName}
        <Typography variant="caption" color="textSecondary" display="block">
          {userProductPackage.userInfo.id}
        </Typography>
      </TableCell>
      <TableCell>
        <Chip
          color={
            userProductPackage.payType === UserProductPackagePayType.ONLINE_PAY
              ? 'secondary'
              : userProductPackage.payType ===
                UserProductPackagePayType.OFFLINE_PAY
              ? 'primary'
              : 'default'
          }
          label={UserProductPackagePayTypeText[userProductPackage.payType]}
          icon={
            userProductPackage.payType ===
            UserProductPackagePayType.ONLINE_PAY ? (
              <CreditCardRoundedIcon />
            ) : userProductPackage.payType ===
              UserProductPackagePayType.OFFLINE_PAY ? (
              <LocalAtmRoundedIcon />
            ) : (
              <FaceRoundedIcon />
            )
          }
          size="small"
        />
      </TableCell>
      <TableCell>{userProductPackage.staffInfo.realName}</TableCell>
      <TableCell>
        {moment(userProductPackage.createDate).format('YYYY-MM-DD HH:mm:ss')}
      </TableCell>
      <TableCell>
        <Chip
          color={
            userProductPackage.status === UserProductPackageOrderStatus.USED
              ? 'primary'
              : 'secondary'
          }
          label={UserProductPackageOrderStatusText[userProductPackage.status]}
          icon={
            userProductPackage.status === UserProductPackageOrderStatus.USED ? (
              <CheckRoundedIcon />
            ) : (
              <CloseRoundedIcon />
            )
          }
          size="small"
        />
      </TableCell>
      <TableCell>
        {userProductPackage.status === UserProductPackageOrderStatus.CANCEL && (
          <span>{userProductPackage.modifiedUserInfo.realName}</span>
        )}
      </TableCell>
      <TableCell>
        {userProductPackage.status === UserProductPackageOrderStatus.CANCEL && (
          <span>
            {moment(userProductPackage.modifiedDate).format(
              'YYYY-MM-DD HH:mm:ss',
            )}
          </span>
        )}
      </TableCell>
      <GroupProductTableCell groupProducts={countProducts} />
      <TableCell align="right">
        <Button
          variant="contained"
          color="default"
          size="small"
          startIcon={<AssignmentIcon />}
          style={{ marginRight: '12px' }}
          onClick={handleOpenDetail}>
          檢視
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default UserProductPackageOrderTableRow;
